import { render } from "./ProgressDoughnutChart.vue?vue&type=template&id=13067e82&scoped=true"
import script from "./ProgressDoughnutChart.vue?vue&type=script&lang=js"
export * from "./ProgressDoughnutChart.vue?vue&type=script&lang=js"

import "./ProgressDoughnutChart.vue?vue&type=style&index=0&id=13067e82&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\Account\\web\\Medical-Account-Web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13067e82"]])

export default __exports__